import { useRef, useState } from "react";

import { Autocomplete, CircularProgress, TextField } from "@mui/material";

import { MenuFilho } from "../../typesSite/menuFilho/MenuFilho";
import useMenuFilhoSiteFetch from "./useMenuFilhoSiteFetch";

type Props = {
  isdisabled?: boolean;
  isLoading?: boolean;
  required?: boolean;
  value?: MenuFilho | null;
  handleSearchChange: (newValue: MenuFilho) => void;
};

const TxtMenuFilhoSite = ({
  isdisabled,
  isLoading,

  required,
  value,
  handleSearchChange,
}: Props) => {
  const timeoutRef = useRef<number | null>(null);
  const loading = useRef(false);

  const handleSetLoad = (newValue: boolean) => {
    loading.current = newValue;
  };

  const [inputValue, setInputValue] = useState("");
  const { options } = useMenuFilhoSiteFetch({ inputValue, handleSetLoad });



  return (
    <Autocomplete
      value={value && value.id ? value : null} //
      size="small"
      options={options}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => {
        const menuFilhoSite = option as MenuFilho;
        let descricao: string = "";
        if (!menuFilhoSite) {
          return "";
        }

        if (menuFilhoSite.label) {
          descricao = menuFilhoSite.label;
        }

        if (menuFilhoSite.menuPai?.label) {
          descricao = "(" + menuFilhoSite.menuPai.label + ") " + descricao;
        }
        return descricao;

        //return menuFilhoSite.descricao ? menuFilhoSite.descricao : "";
      }}
      loading={loading.current}
      onInputChange={(event, newInputValue) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => {
          setInputValue(newInputValue);
        }, 700); // 300ms delay
      }}
      onChange={(event, newValue) => {
        handleSearchChange(newValue as MenuFilho);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Menu secundário - nível 2"
          required={required ? true : false}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading.current ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};
export default TxtMenuFilhoSite;
